'use strict';

var _ = require('lodash');
function ImportCsvUploadingService($q, restangular, advancedGridReloadConfigurationCacheService, advancedHepGridReloadConfigurationCacheCityAptsService) {
  var configurationMarketClassFareUpload = restangular.service('domain').one('mcposAverageFareNew').one('csvUpload');
  var hostShareFileUploadService = restangular.service('configuration').one('hep').one('file').one('hostshare');
  var hepFileUploadService = restangular.service('configuration').one('hep').one('file');
  var hepFileUploadServiceReplace = restangular.service('configuration').one('hep').one('file').one('replace');
  var pricingExclusionRules = restangular.service('external').one('priceExclusion').one('file');
  var marketClassFareInfluencesRules = restangular.service('external').one('mcposAverageFaresOverride').one('file');
  var fareExclusionRules = restangular.service('external').one('faresoptimizer').one('fareexclusionrules').one('file');
  var linkedFbcList = restangular.service('external').one('faresoptimizer').one('linkedfbc').one('file');
  var foMarkets = restangular.service('external').one('faresoptimizer').one('fomarkets').one('file');
  var foCityApts = restangular.service('external').one('faresoptimizer').one('focityapts').one('file');
  var fareBuilderList = restangular.service('external').one('faresoptimizer').one('fareBuilder').one('file');
  var flightTags = restangular.service('domain').one('flightTags').one('file');
  var calendarUploadService = restangular.service('partitioned/seasonality').one('calendarUpload');
  var discontinuedRoute = restangular.service('domain').one('discontinuedRoute').one('file');
  var onlineLogitCalibrationReview = restangular.service('configuration').one('hep').one('file').one('logit');
  var GRID_TO_SAVE_SERVICE_MAP = {
    'configuration-host-share': hostShareFileUploadService,
    'configuration-market-class-fare': configurationMarketClassFareUpload,
    'configuration-user-defined-ref-data-market': hepFileUploadServiceReplace,
    'configuration-user-defined-ref-data-flight': hepFileUploadServiceReplace,
    'holiday-and-special-events': hepFileUploadServiceReplace,
    'configuration-parameters-advanced': hepFileUploadService,
    'user-exclusion-rules': pricingExclusionRules,
    'configuration-market-class-fare-influences': marketClassFareInfluencesRules,
    'user-fare-exclusion-rules': fareExclusionRules,
    'configuration-linked-fbc': linkedFbcList,
    'configuration-fo-markets': foMarkets,
    'configuration-fo-cityapts': foCityApts,
    'configuration-fare-builder': fareBuilderList,
    'seasonality-demand-calendars': calendarUploadService,
    'configuration-flight-tag': flightTags,
    'configuration-discontinued-routes': discontinuedRoute,
    'online-logit-calibration-review': onlineLogitCalibrationReview
  };
  var GRID_TO_MODE_MAP = {
    'configuration-fo-markets': 'fo-markets'
  };
  function getUploadStatistics(response) {
    var rows = response.value || [];
    var uploadStatistics = {};
    if (rows.length) {
      uploadStatistics.allRowsCount = rows.length;
      uploadStatistics.invalidRowsCount = findInvalidRows(rows).length;
      uploadStatistics.persistedRowsCount = rows.length - uploadStatistics.invalidRowsCount;
    } else {
      uploadStatistics.allRowsCount = response.failedRecordsCount + response.persistedRecordsCount;
      uploadStatistics.invalidRowsCount = calculateInvalidRowsCount(response.errorMessages, response.failedRecordsCount);
      uploadStatistics.persistedRowsCount = response.persistedRecordsCount;
      uploadStatistics.errorMessages = _.mapValues(response.errorMessages, function (errorMessage) {
        return _.flatten([errorMessage]);
      });
    }
    return uploadStatistics;
  }
  function calculateInvalidRowsCount(errorMessages, failedRecordsCount) {
    if (!_.isEmpty(errorMessages)) {
      var errorsKeys = _.keys(errorMessages);
      if (_.isArray(errorMessages[errorsKeys[0]])) {
        return _.chain(errorMessages).map(function (value) {
          return value;
        }).flatten().size().value();
      }
    }
    return failedRecordsCount;
  }
  function mapResponse(response) {
    var rows = response.value || [];
    var stats = getUploadStatistics(response);
    return _.extend(stats, {
      rows: rows
    });
  }
  function uploadFile(file, uploader, hepType, domainName, scenarioName, calibrationName, mode) {
    var formData = new FormData();
    formData.append('file', file);
    formData.append('hepType', hepType);
    formData.append('domainName', domainName);
    formData.append('scenarioName', scenarioName);
    formData.append('calibrationName', calibrationName);
    return uploader.customPOST(formData, '', undefined, {
      'Content-Type': undefined
    }).then(function (response) {
      if (mode === 'fo-markets') {
        advancedGridReloadConfigurationCacheService.reloadConfigurationCacheForMode(mode);
      }
      if (mode === 'fo-cityapts') {
        advancedHepGridReloadConfigurationCacheCityAptsService.reloadConfigurationCacheForMode(mode);
      }
      return mapResponse(response);
    });
  }
  function setUpImportErrorLogData(allRows) {
    return _.transform(allRows, function (result, entry, index) {
      var newEntry = _.clone(entry);
      newEntry.rowId = index + 1;
      return result.push(newEntry);
    });
  }
  function findInvalidRows(validatedRows) {
    return _.filter(validatedRows, function (row) {
      return !row.valid;
    });
  }
  function hasFileLevelError(errorMessages, invalidRowsCount) {
    return _.size(errorMessages) === 1 && _.keys(errorMessages)[0] === '' && (invalidRowsCount === 1 || errorMessages[''].length === 1);
  }
  function hasMultipleErrorsPerFileLines(errorMessages, invalidRowsCount) {
    return _.size(errorMessages) === 1 && _.keys(errorMessages)[0] === '' && invalidRowsCount > 1;
  }
  function hasMultipleErrorsForSeveralEntities(errorMessages) {
    return _.size(errorMessages) >= 1 && _.keys(errorMessages)[0] !== '';
  }
  function sendFile(file, gridId, hepType, domainName, scenarioName, calibrationName) {
    var fileUploadApi = GRID_TO_SAVE_SERVICE_MAP[gridId];
    if (fileUploadApi) {
      return uploadFile(file, fileUploadApi, hepType, domainName, scenarioName, calibrationName, GRID_TO_MODE_MAP[gridId]);
    } else {
      return $q.reject();
    }
  }
  return {
    setUpImportErrorLogData: setUpImportErrorLogData,
    hasFileLevelError: hasFileLevelError,
    hasMultipleErrorsPerFileLines: hasMultipleErrorsPerFileLines,
    hasMultipleErrorsForSeveralEntities: hasMultipleErrorsForSeveralEntities,
    sendFile: sendFile,
    mapResponse: mapResponse
  };
}
ImportCsvUploadingService.$inject = ['$q', 'Restangular', 'AdvancedGridReloadConfigurationCacheService', 'AdvancedHepGridReloadConfigurationCacheCityAptsService'];
module.exports = ImportCsvUploadingService;